/* tslint:disable */
/* eslint-disable */
/**
 * LogQS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface Tag {
  id: string;
  createdAt: Date;
  updatedAt: Date | null;
  deletedAt: Date | null;
  createdBy: string | null;
  updatedBy: string | null;
  deletedBy: string | null;
  labelId: string;
  logId: string;
  topicId: string | null;
  note: string | null;
  context: object | null;
  startTime: bigint | null;
  endTime: bigint | null;
}

export function TagFromJSON(json: any): Tag {
  return TagFromJSONTyped(json);
}

export function TagFromJSONTyped(json: any): Tag {
  if (json == null) {
    return json;
  }

  return {
    id: json["id"],
    createdAt: new Date(json["created_at"]),
    updatedAt:
      json["updated_at"] === null ? null : new Date(json["updated_at"]),
    deletedAt:
      json["deleted_at"] === null ? null : new Date(json["deleted_at"]),
    createdBy: json["created_by"],
    updatedBy: json["updated_by"],
    deletedBy: json["deleted_by"],
    labelId: json["label_id"],
    logId: json["log_id"],
    topicId: json["topic_id"],
    note: json["note"],
    context: json["context"],
    startTime: json["start_time"] === null ? null : BigInt(json["start_time"]),
    endTime: json["end_time"] === null ? null : BigInt(json["end_time"]),
  };
}

export function TagToJSON(value: Tag | null | undefined): any {
  if (value == null) {
    return value;
  }

  return {
    id: value.id,
    created_at: value.createdAt.toISOString(),
    updated_at: value.updatedAt === null ? null : value.updatedAt.toISOString(),
    deleted_at: value.deletedAt === null ? null : value.deletedAt.toISOString(),
    created_by: value.createdBy,
    updated_by: value.updatedBy,
    deleted_by: value.deletedBy,
    label_id: value.labelId,
    log_id: value.logId,
    topic_id: value.topicId,
    note: value.note,
    context: value.context,
    start_time: value.startTime === null ? null : value.startTime.toString(),
    end_time: value.endTime === null ? null : value.endTime.toString(),
  };
}
